import { Integration_Auth_Names_Enum, Integration_Names_Enum } from '@main/graphql/types.generated';
import { integrationSchemaRegistry, pemPrivateKeySchema } from '@main/shared/utils';
import { z } from 'zod/v4';

import { IntegrationAuth, IntegrationConnector, IntegrationConnectorCategory } from '../../lib';

export type GoogleDriveConnectorConfig = typeof GoogleDriveConnector._.Config;

export const GoogleDriveConnector = IntegrationConnector.make({
  provider: Integration_Names_Enum.GoogleDrive,
  logoPath: 'images/google-drive-logo.svg',
  categories: [IntegrationConnectorCategory.Productivity],
  auths: IntegrationAuth.group([
    IntegrationAuth.manual({
      name: Integration_Auth_Names_Enum.ServiceAccountPrivateKey,
      configSchema: z.object({
        projectId: z.string().min(1),
        clientEmail: z.email(),
      }),
      encryptedConfigSchema: z.object({
        privateKey: pemPrivateKeySchema().register(integrationSchemaRegistry, {
          presentation: { input: 'textarea' },
        }),
      }),
    }),
  ]),
});
